module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "person-quote"
  }, [_c('div', {
    ref: "image",
    staticClass: "person-quote__wrapper"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.toggleHandler
    }
  }, [_vm._v("Lees quote")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42cf4648","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/quote/quote.vue
// module id = 141
// module chunks = 0